import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-cooked-bread/react-cooked-bread/packages/docs/src/components/layout.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "troubleshoot",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#troubleshoot",
        "aria-label": "troubleshoot permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Troubleshoot`}</h1>
    <h4 {...{
      "id": "toasts-arent-rendering",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#toasts-arent-rendering",
        "aria-label": "toasts arent rendering permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Toasts aren't rendering`}</h4>
    <p>{`Add the toast provider to a top-level position in your app. All consumers must be descendants of the provider (see `}<a parentName="p" {...{
        "href": "/react-cooked-bread/provider"
      }}>{`Provider`}</a>{`).`}</p>
    <h4 {...{
      "id": "toasts-are-ugly-missing-styles-no-close-button-no-icons",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#toasts-are-ugly-missing-styles-no-close-button-no-icons",
        "aria-label": "toasts are ugly missing styles no close button no icons permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Toasts are ugly (missing styles, no close button, no icons)`}</h4>
    <p>{`Make sure you have passed the required props to `}<inlineCode parentName="p">{`ToastProvider`}</inlineCode>{`. If you'd like to use components provided by this library, you'll need to import components such as `}<inlineCode parentName="p">{`SlideShrinkToastRoot`}</inlineCode>{` and `}<inlineCode parentName="p">{`GlossyToastContent`}</inlineCode>{` to the `}<inlineCode parentName="p">{`ToastProvider`}</inlineCode>{` (see `}<a parentName="p" {...{
        "href": "/react-cooked-bread/provider"
      }}>{`Provider`}</a>{` or `}<a parentName="p" {...{
        "href": "/react-cooked-bread/quick-start"
      }}>{`Quick Start`}</a>{`).`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      